<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        Revenue
      </h5>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body text-center">
      <span style="font-size: 48px">
        {{ revenue | price }}
      </span>

      <br>

      <span style="font-size: 18px">
        <span v-if="target">
          Target: {{ target | price }}
        </span>

        <span v-else>
          &nbsp;
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import SaveHeight from '@/mixins/SaveHeight'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  mixins: [SaveHeight],

  props: ['year', 'targetMetric'],

  data() {
    return {
      loading: true,
      revenue: null,
      target: null
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'ad_value_after_costs'},
          {name: this.targetMetric},
        ],
        filters: [
          {dimension: 'publish_year', operator: '=', value: this.year},
        ]
      }).then(response => {
        this.revenue = response.data.data[0].ad_value_after_costs

        this.target = response.data.data[0][this.targetMetric]

        this.loading = false
      })
    }
  }
}
</script>
